module.exports = __webpack_public_path__ + "tc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tc.svg
// module id = 829
// module chunks = 0